export const WEBSITE_BASE_URL = 'https://www.mygamecenter.club';
export const EXTENSION_CONTENT_PATH = '/extension-content';
export const WIDGET_CONTENT_PATH = '/ext-params';
export const GAME_CARD_NUM = 7;
